<template>
  <div class="echars">
    <div id="echarth-nannv"></div>
  </div>
</template>

<script>
export default {
  name: "echarth-nannv",
  props:["title"],
  data() {
    return {
      value1: {}
    }
  },
  watch: {
    title: function (newData) {
      this.value1 = newData
      let data = []
      for(let i=0;i<this.value1.length;i++){
        
        if(this.value1[i].sex==="1"){
          data[i] = {value:this.value1[i].count,name:"男生"}
          
        }else{
          data[i] = {value:this.value1[i].count,name:"女生"}
        }
      }
      this.mapFn(data)
    }
  },
  methods: {
    mapFn(item) {
      let _this = this
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      var mapChart = this.$echarts.init(
        document.getElementById("echarth-nannv")
      );
      document
        .getElementById("echarth-xueli")
        .removeAttribute("_echarts_instance_");
      mapChart.setOption({
        color: ["#0b41eb", "#81afd4"],

        series: [
          {
            name: "Access From",
            type: "pie",
            radius:[0,'80%'],
            label: {
              show: true,
              position: "inner",
              formatter: "{b}{d}%",
            },
            data: item,
            // [
            //   { value: _this.value1.con, name: "男生" },
            //   { value: data.nv, name: "女生" },
            // ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      }),
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          mapChart.resize();
        });
    },
  },
  mounted() {
    // this.mapFn();
  },
};
</script>
<style scoped>
.echars {
  width: 23vw;
  height: 35vh;
}
#echarth-nannv {
  width: 23vw;
  height: 35vh;
}
</style>
